export const GA_ID = "G-2MKW849L46";
const KEY = "analytics-consent";
type AnalyticsWindow = Window & {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
};
let enabled = false;
let memoryChoice: string | null = null;

export function analyticsChoice(): string | null {
  try {
    const value = localStorage.getItem(KEY) ?? memoryChoice;
    return value === "accepted" || value === "declined" ? value : null;
  } catch { return memoryChoice; }
}

export function startAnalytics() {
  if (enabled || analyticsChoice() !== "accepted") return;
  enabled = true;
  const target = window as AnalyticsWindow;
  target.dataLayer = target.dataLayer || [];
  target.gtag = function () { target.dataLayer!.push(arguments); };
  target.gtag("js", new Date());
  target.gtag("config", GA_ID, { allow_google_signals: false, allow_ad_personalization_signals: false });
  // Keep local QA events inspectable without polluting the live property.
  if (["localhost", "127.0.0.1", "[::1]"].includes(location.hostname)) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function chooseAnalytics(accept: boolean) {
  memoryChoice = accept ? "accepted" : "declined";
  try { localStorage.setItem(KEY, accept ? "accepted" : "declined"); } catch { /* Storage may be unavailable. */ }
  if (accept) startAnalytics();
  window.dispatchEvent(new Event("analytics-choice"));
}

export function track(name: string, parameters: Record<string, string | number> = {}) {
  if (!enabled) return false;
  (window as AnalyticsWindow).gtag?.("event", name, parameters);
  return true;
}

export function resetAnalytics() {
  enabled = false;
  memoryChoice = null;
  (window as unknown as Record<string, unknown>)[`ga-disable-${GA_ID}`] = true;
  try { localStorage.removeItem(KEY); } catch { /* Keep settings usable without storage. */ }
  // Remove this property's first-party GA cookies on the host and parent domain.
  const hostParts = location.hostname.split(".");
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.trim().split("=")[0];
    if (!name || !(name === "_ga" || name === "_ga_2MKW849L46")) continue;
    document.cookie = `${name}=; Max-Age=0; path=/`;
    for (let i = 0; i < hostParts.length - 1; i++) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${hostParts.slice(i).join(".")}`;
    }
  }
  location.reload();
}
